<div class="wrapper">
  <div class="m-box">
    <h2>{{'appointments.gui.labels.Performer Price List' | translate}}</h2>
    <div *ngIf="byRoom" style="margin-bottom: 1em; max-width: 20em;">
      <label>{{'billing.gui.labels.Doctor' | translate}}</label>
      <select class="t-select w100" [(ngModel)]="performerUID" [compareWith]="sameId" (ngModelChange)="onPerformerChange()">
        <option *ngFor="let user of performers" [ngValue]="user.UID">{{user.Title + ' ' + user.Name}}</option>
      </select>
    </div>
    <table>
      <tr>
        <th>{{'billing.gui.labels.Exam Name' | translate}}</th>
        <th>{{'appointments.gui.labels.Payer' | translate}}</th>
        <th>{{'appointments.gui.labels.Reimbursement Amount' | translate}}</th>
        <th>{{'appointments.gui.labels.Performer Remuneration Percent' | translate}}</th>
        <th>{{'appointments.gui.labels.Performer Remuneration Sum' | translate}}</th>
        <th></th>
      </tr>
      <tr [ngClass]="price.isEditing ? 'tr-isActive' : ''" *ngFor="let price of prices">
        <td style="width: 20%;">
          <select class="t-select w100" [(ngModel)]="price.examId" [compareWith]="sameId" [disabled]="!price.isEditing">
            <option *ngIf="!hasExam(price.examId)" [ngValue]="price.examId">{{price.examName}}</option>
            <option *ngFor="let exam of allExams" [ngValue]="exam.AutoIndex">{{exam.examName}}</option>
          </select>
        </td>
        <td>
          <select class="t-select w100" [(ngModel)]="price.payer" [disabled]="!price.isEditing">
            <option *ngFor="let payer of financialService.payers" [value]="payer">{{financialService.payerMapping[payer]}}</option>
          </select>
        </td>
        <td>
          <input class="search-patient-field menstural-field" type="number" min="0" [(ngModel)]="price.reimbursementPrice" (ngModelChange)="onBaseChange(price)" [disabled]="!price.isEditing">
        </td>
        <td>
          <input class="search-patient-field menstural-field" type="number" min="0" max="100" [(ngModel)]="price.remunerationPercent" (ngModelChange)="onPercentChange(price)" [disabled]="!price.isEditing">
        </td>
        <td>
          <input class="search-patient-field menstural-field" type="number" min="0" [(ngModel)]="price.remunerationSum" (ngModelChange)="onSumChange(price)" [disabled]="!price.isEditing">
        </td>
        <td>
          <button class="blue-btn" *ngIf="!price.isEditing" (click)="edit(price)">{{'appointments.gui.buttons.Edit' | translate}}</button>
          <button class="orange-btn" *ngIf="price.isEditing" (click)="saveChanges(price)">{{'appointments.gui.buttons.Save' | translate}}</button>
          <button class="orange-btn" (click)="remove(price)">{{'appointments.gui.buttons.Delete' | translate}}</button>
        </td>
      </tr>
      <tr>
        <td style="width: 20%;">
          <select class="t-select w100" [(ngModel)]="newPrice.examId" [compareWith]="sameId">
            <option *ngFor="let exam of doctorExams" [ngValue]="exam.AutoIndex">{{byRoom ? examTypeLabel(exam) : exam.examName}}</option>
          </select>
        </td>
        <td>
          <select class="t-select w100" [(ngModel)]="newPrice.payer">
            <option *ngFor="let payer of financialService.payers" [value]="payer">{{financialService.payerMapping[payer]}}</option>
          </select>
        </td>
        <td>
          <input class="search-patient-field menstural-field" type="number" min="0" [(ngModel)]="newPrice.reimbursementPrice" (ngModelChange)="onBaseChange(newPrice)">
        </td>
        <td>
          <input class="search-patient-field menstural-field" type="number" min="0" max="100" [(ngModel)]="newPrice.remunerationPercent" (ngModelChange)="onPercentChange(newPrice)">
        </td>
        <td>
          <input class="search-patient-field menstural-field" type="number" min="0" [(ngModel)]="newPrice.remunerationSum" (ngModelChange)="onSumChange(newPrice)">
        </td>
        <td>
          <button style="white-space: nowrap;" class="orange-btn" (click)="saveNew()">{{'appointments.gui.buttons.Save New' | translate}}</button>
        </td>
      </tr>
    </table>
    <p *ngIf="error" class="error-text">{{errorMessage || ('appointments.gui.labels.Financial Save Error' | translate)}}</p>
  </div>
</div>
